import { API_CONFIG } from "../config/api.config";
import { apiRequest } from "./apiUtils";
import type {
  VisitReportForReview,
  ReviewReportsQuery,
  PaginatedResponse,
  ApiResponse,
} from "../types/review-reports.types";

export class ReviewReportsService {
  /**
   * 获取待审核报告列表
   */
  static async getReviewReports(
    params: ReviewReportsQuery
  ): Promise<PaginatedResponse<VisitReportForReview>> {
    const searchParams = new URLSearchParams();

    if (params.customerName) {
      searchParams.append("customerName", params.customerName);
    }
    if (params.elderName) {
      searchParams.append("elderName", params.elderName);
    }
    if (params.staffName) {
      searchParams.append("staffName", params.staffName);
    }
    if (params.startDate) {
      searchParams.append("startDate", params.startDate);
    }
    if (params.endDate) {
      searchParams.append("endDate", params.endDate);
    }
    if (params.reviewedStartDate) {
      searchParams.append("reviewedStartDate", params.reviewedStartDate);
    }
    if (params.reviewedEndDate) {
      searchParams.append("reviewedEndDate", params.reviewedEndDate);
    }
    if (params.page) {
      searchParams.append("page", params.page.toString());
    }
    if (params.limit) {
      searchParams.append("limit", params.limit.toString());
    }
    if (params.state) {
      searchParams.append("state", params.state.toString());
    }

    const url = `${API_CONFIG.ENDPOINTS.PENDING_REPORTS}${
      searchParams.toString() ? `?${searchParams.toString()}` : ""
    }`;

    return apiRequest<PaginatedResponse<VisitReportForReview>>(url, "GET");
  }

  /**
   * 审核通过报告
   */
  static async approveReport(
    id: number,
    updateData?: Partial<VisitReportForReview>
  ): Promise<ApiResponse<{ id: number; status: string }>> {
    return apiRequest<ApiResponse<{ id: number; status: string }>>(
      API_CONFIG.ENDPOINTS.PENDING_REPORT_APPROVE(id),
      "PUT",
      updateData || {}
    );
  }

  /**
   * 审核拒绝报告
   */
  static async rejectReport(
    id: number
  ): Promise<ApiResponse<{ id: number; status: string }>> {
    return apiRequest<ApiResponse<{ id: number; status: string }>>(
      API_CONFIG.ENDPOINTS.PENDING_REPORT_REJECT(id),
      "PUT"
    );
  }
}
